import src from "IMAGE";
export default { src, width: 2356, height: 612, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AKGmt7K2xMbJ09DT29rc49fZ4dDT29/h5gCorb21uca+ws2xtsSmq7utssC2usersL+iaiSTCpu3mwAAAABJRU5ErkJggg=="};
